import { Flex } from "antd"
import React from "react"

import { cn } from "../utils/cn.ts"

interface FixedContainerProps {
  /**
   * Drops the bottom reserve, so the page's last row can rest where the
   * support button covers it while slid out.
   */
  flushBottom?: boolean
}

export function FixedContainer({
  flushBottom = false,
  children
}: React.PropsWithChildren<FixedContainerProps>) {
  return (
    <div className={"grid size-full min-h-0"}>
      <Flex
        vertical
        gap={"small"}
        data-testid={"fixed-container"}
        // The support widget slides out over the bottom-right corner, so the
        // column reserves 96px below its last card — otherwise the bottom-most
        // row of actions cannot be scrolled out from under it.
        //
        // That reserve is padding, and a sticky child's travel stops at the
        // content edge above it, so anything sticking to the bottom halts 96px
        // short of the visible one. `--floating-action-inset` publishes the
        // reserve so such a child can subtract it back; `TableAddAction` does.
        className={cn(
          "min-h-0 max-h-[calc(100vh-88px)] overflow-auto p-1 -m-1",
          !flushBottom && "pb-24 [--floating-action-inset:6rem]"
        )}
      >
        {children}
      </Flex>
    </div>
  )
}
